// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__37Iz4","header":"MergedInvoice_header__22cif"};